<template>
  <div
    class="container">
    <li
      class="collection-navigation-item"
      v-for="collection in sortedCollections"
      :key="collection.id">
      <div
        v-if="!hiddenCollections.includes(collection.id) || selectedCollection === collection.id"
        class="collection-item"
        :class="{
          'active-collection-item': ($route.params && collection.id == $route.params.collectionId) && ($route.name.includes('Collection') || $route.name.includes('Notes')) && !searchTerms.length,
          'selected-collection-item': collection.id === selectedCollection,
        }"
        :style="{ 'paddingLeft': `${0.5 + (indent(collection) * 1)}rem`}"
        :ref="`nav-item-${collection.id}`">
        <span
          class="icon icon-nav-item"
          @click="toggleChildren(collection.id)">
          <i :class="getIconClass(collection.id)" />
        </span>
        <div
          class="collection-item-text"
          @click="navigateOrToggleChildren(collection.id)">
          {{ collection.name }}
        </div>
      </div>

      <!-- CHILDREN -->
      <ul
        v-if="expandedCollections.includes(collection.id)"
        class="sub"
        :class="{ 'sub-active': expandedCollections.includes(collection.id) }">
        <CollectionNavigationItems
          :collections="collection.children"
          :isRoot="false" />
      </ul>
    </li>

    <!-- CONTEXT MENU -->
    <transition name="fade">
      <div
        v-if="false"
        class="collection-list-item-menu"
        @click="$emit('hide-menu')"
        ref="contextMenu">
        <div>
          <div
            class="collection-list-item-menu-item"
            style="fontWeight: bold">
            Open
          </div>
        </div>
        <div class="collection-list-item-menu-divider" />
        <div
          class="collection-list-item-menu-item">
          Rename
        </div>
        <div
          class="collection-list-item-menu-item">
          Move
        </div>
        <div class="collection-list-item-menu-divider" />
        <div
          class="collection-list-item-menu-item"
          style="color: red">
          Delete
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'CollectionNavigationItems',
  props: {
    collections: Array,
    isRoot: Boolean,
  },
  computed: {
    ...mapState({
      collectionNodes: state => state.collections.collectionNodes,
      selectedCollection: state => state.collections.selectedCollection,
      hiddenCollections: state => state.users.settings.hiddenCollections,
      expandedCollections: state => state.appState.expandedCollections,
      notes: state => state.notes.notes,
      searchIsActive: state => state.appState.search.isActive,
      searchTerms: state => state.search.terms,
    }),
    sortedCollections() {
      const collectionsToSort = this.collections.slice();
      const sorted = collectionsToSort.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return sorted;
    },
  },
  methods: {
    ...mapActions({
      setSearchState: 'appState/setSearchState',
    }),
    ...mapMutations({
      ToggleExpandCollection: 'appState/ToggleExpandCollection',
    }),
    indent(collection) {
      let indent = 0;
      let currentlyChecking = collection;
      while (currentlyChecking.parent.id !== 0) {
        indent += 1;
        currentlyChecking = currentlyChecking.parent;
      }
      return indent;
    },
    toggleChildren(collectionId) {
      if (!this.collectionNodes[collectionId].children.length) return;

      this.ToggleExpandCollection(collectionId);
    },
    getIconClass(collectionId) {
      const hasChildren = !!this.collectionNodes[collectionId].children.length;
      const showsChildren = this.expandedCollections.includes(collectionId);

      return {
        'mdi mdi-menu-up': hasChildren && showsChildren,
        'mdi mdi-menu-down': hasChildren && !showsChildren,
        '': !hasChildren,
      };
    },
    navigateOrToggleChildren(collectionId) {
      if (collectionId === this.selectedCollection && this.searchIsActive && this.searchTerms.length) {
        // Cancel search to view selectedCollection
        this.setSearchState({ isActive: false, displayResults: false });
      }
      else if (collectionId === this.selectedCollection && this.$route.name === 'Collection') {
        // If already selected and in collectionView, toggle children
        this.toggleChildren(collectionId);
      }
      else this.$goToCollection({ id: collectionId });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.collection-navigation-item {
  position: relative;
  background: inherit;
}
ul, li {
  list-style: none;
  font-weight: 300;
  position: relative;
  user-select: none;
}
.selected-collection-item {
  background-color: $primary;
}
.active-collection-item {
  background-color: $secondary-light;
}
.sub {
  height: 0px;
  overflow: hidden;
  position: relative;
  padding-left: 0rem;
  margin: 0;
  list-style: none;
  flex-grow: 1;
}
.sub-active {
  height: auto;
}
.collection-item {
  cursor: pointer;
  display: flex;
  padding: 0.125rem 0;
  transition: background-color 0.3s;
}
.collection-item-text {
  flex-grow: 1;
  font-family: $headerFont;
  padding-left: 0.25rem;
  padding-top: 0.15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.collection-item:hover .icon-nav-item {
  opacity: 1;
}
.icon-nav-item {
  opacity: 0.4;
  padding-top: 0.125rem;
}
.icon {
  height: 100%;
  width: 1rem;
  cursor: pointer;
  color: $black;
  transition: all 0.2s;
}

// CONTEXT MENU
.collection-list-item-menu,
.collection-list-item-menu-sub {
  position: absolute;
  width: 10rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  background-color: #eeeeee !important;
  box-shadow: 1px 1px 3px 1px $primary-dark;
  border-radius: 0 0.25rem 0.25rem 0.25rem;
  font-size: 0.8rem;
  opacity: 1;
  padding: 0 !important;
  white-space: normal;
  z-index: 5;
}
.collection-list-item-menu-sub {
  top: -2rem;
  max-height: 135px;
  overflow-y: auto;
}
.collection-list-item-menu-header {
  cursor: default !important;
  background-color: #eeeeee !important;
}
.collection-list-item-menu .disabled {
  color: $primary-dark;
  font-style: italic;
  cursor: default;
  background-color: #eeeeee !important;
}
.collection-list-item-menu-divider {
  border-bottom: 1px solid $primary;
  margin: 0.25rem 0;
}
.collection-list-item-menu-item {
  position: relative;
  cursor: pointer;
  user-select: none;
  width: 100%;
  padding: 0.25rem 0.5rem !important;
  font-family: $headerFont;
}
.collection-list-item-menu-item:first-child {
  margin-top: 0.25rem;
}
.collection-list-item-menu-item:last-child {
  margin-bottom: 0.25rem;
}
.collection-list-item-menu-item:hover {
  background-color: $primary-light;
}
.collection-list-item-menu-item:hover > .new-section-input {
  background-color: $primary-light !important;
}
.collection-list-item-menu-item .new-section-input {
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  font-family: $headerFont;
  background-color: #eeeeee !important;
}
</style>
